// extracted by mini-css-extract-plugin
export default {"body":"styles_body__CQgYI","bone-skeleton":"styles_bone-skeleton__36Y4y"};